export default {
  main: {
    title: 'Pagpapatunay ng Bersyon',
    language: 'Filipino',
    intro:
      'Ang pagpapatunay ng bersyon ay isinasagawa sa pamamagitan ng pagtugma ng mga halaga ng MD5 o SHA256 hash sa pagitan ng mga bersyon. Mangyaring tiyakin na i-download ang TokenPocket wallet sa pamamagitan ng mga opisyal na channel upang maiwasan ang pagkakaloko. Para sa mga tagubilin kung paano makakuha ng mga halaga ng MD5 o SHA256 hash ng isang bersyon, mangyaring ',
    tutorial: 'tingnan ang tutorial >',
    system: 'OS',
    android: 'Android',
    ios: 'iOS',
    version: 'Bersyon',
    allVersion: 'Lahat',
    appChannel: 'App Channel',
    developer: 'developer',
    allChannel: 'Lahat',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Tala ng Bersyon',
    check: 'Detalye',
    versionLog: 'Tala ng Bersyon',
    confirm: 'Kumpirmahin',
    aboutIOS: 'Tungkol sa iOS Version',
    IOSDesc:
      'Para sa mga bersyon ng iOS, kami lamang ang nag-aalok ng aming App sa App Store. Tanging mga apps na i-download sa pamamagitan ng App Store ang maaaring maayos na ma-install. Kaya kapag gumagamit ng mga Apple device, tiyakin na authenticated ang App Store bilang eksklusibong channel para sa pag-download.',
    IOSDesc_2:
      'Ang developer ng bersyon na i-download mula sa App Store bago ang Oktubre 8, 2022 ay ang TOKENPOCKET FOUNDATION LTD, na isang maagang bersyon na binuo ng TokenPocket. Ito ay isang lehitimong wallet na maaaring normal na gamitin, ngunit pansamantalang suspindihin ang serbisyo ng pag-update.',
    aboutAndroid: 'Tungkol sa Bersyon ng Android',
    androidDesc: 'Ang mga channel ng pag-download ng TokenPocket para sa Android kasalukuyang kasama ang opisyal na website, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store, at Vivo App Store. Sa ilang mga app store, hindi makuha ang APK installation package habang nagdodownload, kaya hindi maaaring isagawa ang MD5 o SHA256 verification. Kaya, sa pag-download, tiyaking tumpak ang impormasyon ng developer at sumangguni sa ibaba!',
    IOSAppName: 'Pangalan ng Application:',
    TPWallet: 'TP Wallet',
    AppIcon: 'App Icon:',
    AppDeveloper: 'Developer:',
    downloadLink: 'Link ng Pag-download:',
    copied: 'Nakopya!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Sundan mo kami',
    desc1:
      'Ang TokenPocket Staffs ay hindi magpapadala sa iyo ng mga pribadong mensahe!',
    desc2:
      'Ingat! Pumapasok ka sa komunidad ng TokenPocket, maaaring may gumagaya sa amin para magpadala sa iyo ng mga pribadong mensahe! Mangyaring magkaroon ng kamalayan na, sinuman na nagpapadala ng mga pribadong mensahe ay maaaring isang scammer! Hindi ka muna namin makokontak!',
    desc3: 'Naiintindihan, pumasok',
  },
  COMMON: {
    LAYOUT: {
      features: 'Mga tampok',
      products: 'Produkto',
      buyCryptoFooter: 'Bumili ng Crypto',
      mobileWallet: 'Mobile Wallet',
      mobileWalletDesc: 'Crypto&DeFi Mobile Wallet sa Blockchain.',
      hardwareWallet: 'Hardware Wallet',
      hardwareWalletDesc: 'Kunin ang iyong KeyPal, para maingatan ang iyong mga asset.',
      extensionWallet: 'Extension Wallet',
      extensionWalletDesc: 'Mas magandang wallet sa iyong computer.',
      desktop: 'Desktop na Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'Pag-verify ng Bersyon',
      versionVerificationDesc: 'I-verify ang iyong wallet.',
      approvalDetector: 'Approval Detector',
      approvalDetectorDesc: 'Tingnan at I-unapprove ang Iyong Mga Na-approve na Token.',
      tokenSecurity: 'Seguridad ng Token',
      tokenSecurityDesc: 'I-verify kung ligtas ang token sa pamamagitan ng contract address nito.',
      keyGenerator: 'Key Generator',
      keyGeneratorDesc: 'Generate ng Random Pampubliko at Private Key para sa Network.',
      tokenProfile: 'Token Profile',
      tokenProfileDesc: 'Alamin ang lahat ng impormasyon tungkol sa token.',
      tokenClaim: 'Token Claim',
      tokenClaimDesc: 'I-claim ang Iyong Airdrop.',
      easyInscription: 'Madaling Inscription',
      easyInscriptionDesc: 'Isang Secure na Inscription tool.',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'Isang Batch Sending Tool para sa NostrAssets.',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'Magpadala ng Mga Token sa Maraming Tumatanggap nang Sabay-sabay.',
  
      trade: 'Trade',
      swap: 'Transit Swap',
      swapDesc: 'Magpalit sa pinakamagandang presyo.',
      bridge: 'Bridge',
      bridgeDesc: 'Ensuring seamless asset liquidity.',
      buyCrypto: 'Bumili',
      buyCryptoDesc: 'Bumili ng cryptocurrency gamit ang iyong mga credit card.',
      market: 'Market',
      marketDesc: 'Mga real-time na pananaw para matuklasan ang mga trending na token.',
  
      information: 'Impormasyon',
      blockchainGuide: 'Gabay sa Blockchain',
      tronWallet: 'Gabay sa TRON',
      iostWallet: 'Gabay sa IOST',
      tpMan: 'TP Man',
  
      developers: 'Mga developer',
      github: 'Github (TP-Lab)',
      devCenter: 'Dev Center',
      developersDesc: 'TokenPocket developer dokumentansyon.',
      subToken: 'I-submit ang Token',
      subTokenDesc: 'I-submit ang iyong token.',
      subDApp: 'I-submit ang DApp',
      subDAppDesc: 'I-submit ang iyong DApp, at ipakita ito pagkatapos ng audit.',
      subNFT: 'I-submit ang NFT',
      subNFTDesc: 'I-submit ang iyong NFT at sining.',
      subChain: 'I-submit ang Chain',
      subChainDesc: 'I-submit ang iyong blockchain.',
      bugBounty: 'Gantimpala sa Bugs',
  
      tools: 'Mga Tool',
  
      build: 'Gumawa',
  
      learn: 'Matuto',
  
      explorer: 'Galugarin',
  
      company: 'kumpanya',
      about: 'Tungkol sa',
      careers: 'Mga Career',
      pressKit: 'Kitis ng Tatak',
      swagShop: 'Swag Shop',
  
      support: 'Suporta',
      helpCenter: 'Help Center',
      helpCenterDesc: 'Ang iyong mga pangunahing mapagkukunan para sa mga sagot at tulong.',
      contactUs: 'Makipag-ugnayan sa Amin',
      contactUsDesc: 'Ibahagi ang iyong mga mungkahi at magtanong ng anumang mga katanungan.',
      forum: 'Forum',
      forumDesc: 'Makipag ugnayan sa iyong mga pag-uusap sa mga miyembro ng komunidad.',
  
      legal: 'Legal',
      privacyPolicy: 'Patakaran sa Privacy',
      terms: 'Mga Tuntunin ng Paggamit',
  
      toHome: 'Home',
      defiWallet: 'DeFi na Wallet',
      ETHWallet: 'Ethereum Wallet',
      ethWallet: 'ETH na Wallet',

      dappStore: 'DApp Store'
    }
  }
};
